import { render } from "./world-class.vue?vue&type=template&id=23593295&scoped=true"
import script from "./world-class.vue?vue&type=script&lang=js"
export * from "./world-class.vue?vue&type=script&lang=js"

import "./world-class.vue?vue&type=style&index=0&id=23593295&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23593295"]])

export default __exports__